module.exports = __webpack_public_path__ + "static/media/vectory.63b69417.svg";